import { render } from "./ReplacementsDue.vue?vue&type=template&id=d0e47bcc"
import script from "./ReplacementsDue.vue?vue&type=script&lang=js"
export * from "./ReplacementsDue.vue?vue&type=script&lang=js"

import "./ReplacementsDue.vue?vue&type=style&index=0&id=d0e47bcc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__